import { celebrityInfo } from '@/mocks/site';

export default function QuickFacts() {
  const facts = [
    { label: '本名', value: `${celebrityInfo.name}（${celebrityInfo.nameJp}）` },
    { label: '英文名', value: celebrityInfo.nameEn },
    { label: '生日', value: celebrityInfo.birthday },
    { label: '出生地', value: celebrityInfo.birthplace },
    { label: '身高', value: celebrityInfo.height },
    { label: '三围', value: celebrityInfo.measurements },
    { label: '血型', value: celebrityInfo.bloodType },
    { label: '出道', value: celebrityInfo.debut },
  ];

  return (
    <section className="py-12 md:py-16 bg-foreground-950">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-bold text-background-50 font-[family-name:var(--font-heading)]">
            快速档案
          </h2>
          <p className="mt-2 text-sm text-foreground-400">Quick Facts</p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {facts.map((fact) => (
            <div
              key={fact.label}
              className="p-4 rounded-lg bg-foreground-900 border border-foreground-800 text-center hover:border-primary-500/50 transition-colors duration-300"
            >
              <p className="text-xs text-foreground-500 mb-1">{fact.label}</p>
              <p className="text-sm font-medium text-background-50">{fact.value}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}